import { Dialog, DialogProps, useMediaQuery } from '@mui/material';
import React, { CSSProperties } from 'react';
import { ReactNode } from 'react';
import theme from 'theme';

interface RoundedDialogProps extends DialogProps {
    open: boolean;
    children?: ReactNode | ReactNode[];
    style?: CSSProperties;
}

export default function RoundedDialog({ open, children, style, ...dialogProps }: RoundedDialogProps) {
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Dialog
            open={open}
            PaperProps={{
                style: {
                    borderRadius: 20,
                    minWidth: smDown ? '90%' : '35%',
                    ...style,
                },
            }}
            BackdropProps={{
                style: {
                    backgroundColor: `rgba(0, 47, 77, 0.75)`,
                },
            }}
            {...dialogProps}
        >
            {children}
        </Dialog>
    );
}
